import { NgModule } from '@angular/core';
import { Routes,
     RouterModule } from '@angular/router';

import { AuthGuard } from '../_guards/index';

import { DashboardComponent } from './dashboard.component'; 
const routes: Routes = [
  {
    path: '',
    component: DashboardComponent,
    data: {
      title: 'Dashboard'
    }, canActivate: [AuthGuard]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class DashboardRoutingModule {}



// WEBPACK FOOTER //
// ./src/app/dashboard/dashboard-routing.module.ts